export default __webpack_public_path__ + "static/media/yw-icons.02f129e4.eot";